import { Action } from '@ngrx/store';
import { Account } from '../../profile/models/profile';

export enum ProfileActionTypes {
  SetActiveAccount = '[Profile] Set active account',
  LoadRequested = '[Profile] Load account requested',
  LoadSuccess = '[Profile] Load account success',
  LoadFailed = '[Profile] Load account failed'
}

export class SetActiveAccount implements Action {
  public readonly type: string = ProfileActionTypes.SetActiveAccount;
  public readonly location: boolean = true;

  constructor(public payload?: string) {}
}

export class LoadAccountRequested implements Action {
  public readonly type: string = ProfileActionTypes.LoadRequested;
  public readonly payload = undefined;
}

export class LoadAccountSuccess implements Action {
  public readonly type: string = ProfileActionTypes.LoadSuccess;

  constructor(public payload: Account) {}
}

export class LoadAccountFailed implements Action {
  public readonly type: string = ProfileActionTypes.LoadFailed;
  constructor(public payload: string) {}
}

export type ProfileActionUnion =
  | SetActiveAccount
  | LoadAccountRequested
  | LoadAccountSuccess
  | LoadAccountFailed;
